// @flow
export const partnerPlacesToServiceProviders = (paging: PaginationResponse<PartnerPlace>): ServiceProvider[] => {
  return paging.results.map(p => p._embedded.service_provider)
}